var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTetonView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 16",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5914 15.9623L15.1442 16C15.0127 16 14.8876 15.9372 14.8116 15.8305L11.0691 10.5688C10.8046 10.1969 10.0159 10.8278 9.50591 11.14C9.32536 11.2515 9.08938 11.2044 8.96426 11.0333L5.96933 6.88426C5.86797 6.7446 5.86955 6.55472 5.9725 6.41506L10.4372 0.390733C10.5322 0.262055 10.7175 0.0957151 10.8189 0.0219606C10.9202 -0.0517938 11.3003 0.0768841 11.3779 0.18987L15.7539 6.70694C15.8426 6.83875 16.001 6.90623 16.1578 6.87955L17.6165 6.62847C17.7828 6.60023 17.9491 6.67712 18.0346 6.82149L19.9462 10.0777C19.9826 10.1389 20.0016 10.2079 20.0001 10.2785L19.9906 15.5653C19.9906 15.785 19.8116 15.9623 19.5914 15.9639V15.9623Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9601 15.9812L0.460857 15.9859C0.242295 15.9859 0.0649111 15.8117 0.058576 15.5951C0.0142301 13.6273 -0.050705 11.7364 0.0649111 9.86111C0.0696625 9.79363 0.0902516 9.72772 0.126679 9.67123C0.891645 8.4535 1.7453 7.29226 2.60213 6.10591C2.99966 5.55511 3.82323 5.55511 4.22234 6.10277L8.69811 12.2699C8.81055 12.4253 9.01961 12.4802 9.19383 12.3986C9.58502 12.215 9.9097 12.0204 10.3009 11.7724C10.483 11.6579 10.7238 11.705 10.8457 11.8807L13.2895 15.355C13.4748 15.6187 13.2847 15.9812 12.9601 15.9812Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTetonView);
export default __webpack_public_path__ + "static/media/teton-view.b84b28101bebea3829ec9f8a161e02e8.svg";
export { ForwardRef as ReactComponent };